export default "__VITE_ASSET__D_PdaG35__"